<div class="factory-summary">
    <span class="header-i-icon-main">
        <img *ngIf="insightLevel==='factory'" src="../../../assets/images/icn-info.svg" class="header-i-icon" alt=""
            [popover]="totalwastefactory" triggers="mouseenter:mouseleave" container="body" placement="right">
        <img *ngIf="insightLevel==='line'" src="../../../assets/images/icn-info.svg" class="header-i-icon" alt=""
            [popover]="totalwasteline" triggers="mouseenter:mouseleave" container="body" placement="right">
        <div class="factory-summary-header">

            <div class="logo"
                *ngIf="insightLevel==='factory' && factorySummary && factorySummary.factoryImage && factorySummary.factoryImage != ''">
                <img [src]="factorySummary?.factoryImage" alt="logo" />
            </div>
            <div class="name">
                <div class="current-level">
                    <span *ngIf="insightLevel==='factory'">{{factorySummary?.factoryName}}</span>
                    <span *ngIf="insightLevel==='line'">{{lineName}}</span>
                </div>
                <div class="parent-level ">
                    <div class="legend legend-color">Total Waste : <span class="legend_label"
                            innerHTML="{{factorySummaryKPI?.totalWaste | cost}}"></span>
                        <span class="f-12" *ngIf="factorySummaryKPI?.totalWastePercentage !== 0">
                            ( {{factorySummaryKPI?.totalWastePercentage + '%'}}
                        </span>
                        <span *ngIf="factorySummaryKPI?.totalWastePercentage === 0" class="fs-zero f-12">
                            ( - )</span>
                        <ng-container class="f-12" *ngIf="factorySummaryKPI?.totalWastePercentage !== 0">
                            <mat-icon class="arrow_upward" *ngIf="!factorySummaryKPI?.arrow">arrow_upward <span
                                    style="color:#004976;font-weight: 400!important;">)</span></mat-icon>
                            <mat-icon class="arrow_downward" *ngIf="factorySummaryKPI?.arrow">arrow_downward <span
                                    style="color:#004976;font-weight: 400!important;">)</span>
                            </mat-icon>
                        </ng-container>
                    </div>

                </div>
            </div>

        </div>
    </span>
    <div class="squares-container" [style.opacity]="!isLoading ? '1' : '0.3'">
        <div class="loader" *ngIf="isLoading">
            <div>Loading...</div>
        </div>
        <div class="square i_icon_main">
            <span class="i_icon">
                <img src="../../../assets/images/icn-info.svg" alt="" [popover]="factorykpi1"
                    triggers="mouseenter:mouseleave" container="body" placement="right">
                <img src="../../../assets/images/icn-info.svg" *ngIf="insightLevel==='line'" alt="" [popover]="linekpi1"
                    triggers="mouseenter:mouseleave" container="body" placement="right">

                <div class="value">
                    {{factorySummaryKPI?.zeroBasedTargetDeviation | number : '1.2-2'}} %
                </div>
                <div class="middle">

                    <span *ngIf="factorySummaryKPI?.zeroBasedTargetDeviationper !== 0">
                        {{factorySummaryKPI?.zeroBasedTargetDeviationper + '%'}}
                    </span>
                    <span *ngIf="factorySummaryKPI?.zeroBasedTargetDeviationper === 0" class="fs-zero">-</span>
                    <ng-container *ngIf="factorySummaryKPI?.zeroBasedTargetDeviationper !== 0">
                        <mat-icon class="arrow_upward" *ngIf="!factorySummaryKPI?.zeroBasedArrow">
                            arrow_upward</mat-icon>
                        <mat-icon class="arrow_downward" *ngIf="factorySummaryKPI?.zeroBasedArrow">
                            arrow_downward</mat-icon>
                    </ng-container>

                </div>
                <div class="legend">Zero Based <br /> Target Deviation</div>
            </span>
        </div>
        <div class="square left i_icon_main">
            <span class="i_icon">
                <img *ngIf="insightLevel==='factory'" src="../../../assets/images/icn-info.svg" alt=""
                    [popover]="factorykpi2" triggers="mouseenter:mouseleave" container="body" placement="right">
                <img *ngIf="insightLevel==='line'" src="../../../assets/images/icn-info.svg" alt="" [popover]="linekpi2"
                    triggers="mouseenter:mouseleave" container="body" placement="right">
                <div class="value">
                    <span>{{factorySummaryKPI?.wasteContribution | number :'1.2-2'}}%</span>
                </div>
                <div class="legend">Cost Contribution <br />
                    <span *ngIf="insightLevel==='factory'">By Sub-Region</span>
                </div>
            </span>
        </div>
        <div class="square top i_icon_main" *ngIf="insightLevel==='factory'">
            <span class="i_icon">
                <img src="../../../assets/images/icn-info.svg" alt="" [popover]="factorykpi3"
                    triggers="mouseenter:mouseleave" container="body" placement="right">
                <div class="value">{{factorySummaryKPI?.uniqueLine}}</div>
                <div class="legend">Unique Line</div>
            </span>
        </div>
        <div class="square top i_icon_main" *ngIf="insightLevel==='line'">
            <span class="i_icon">
                <img src="../../../assets/images/icn-info.svg" *ngIf="insightLevel==='line'" alt="" [popover]="linekpi3"
                    triggers="mouseenter:mouseleave" container="body" placement="right">
                <div class="value">{{factorySummaryKPI?.productionFrequency}}</div>
                <div class="legend">Production Frequency</div>
            </span>
        </div>
        <div class="square left top i_icon_main">
            <span class="i_icon">
                <img *ngIf="insightLevel==='factory'" src="../../../assets/images/icn-info.svg" alt=""
                    [popover]="factorykpi4" triggers="mouseenter:mouseleave" container="body" placement="right">

                <img *ngIf="insightLevel==='line'" src="../../../assets/images/icn-info.svg" alt="" [popover]="linekpi4"
                    triggers="mouseenter:mouseleave" container="body" placement="right">
                <div class="value">{{factorySummaryKPI?.uniqueSKUs}}</div>
                <div class="legend">Unique SKUs</div>
            </span>
        </div>
    </div>
    <div class="carousel-container" [style.opacity]="!isLoadingInsight || !moreinsightloading ? '1' : '0.3'">
        <div class="loader" *ngIf="isLoadingInsight">
            <div>{{message}}</div>
        </div>
        <div class="loader" *ngIf="moreinsightloading">
            <div class="status" *ngIf="insigtsArray.length>2">More insights are being
                loaded<span class="status__dot">.</span><span class="status__dot">.</span><span
                    class="status__dot">.</span>
            </div>
        </div>
        <div class="carousel-body">
            <ngu-carousel #myCarousel [inputs]="carouselConfig" (onMove)="onmoveFn($event)"
                [dataSource]="carouselItems">
                <div *nguCarouselDef="let item;" class="item">
                    <ng-container *ngIf="item">
                        <div class="content" [innerHTML]="item?.content"></div>
                    </ng-container>
                </div>
            </ngu-carousel>
        </div>
        <div class="carousel-footer">
            <div class="page-counter">
                <span *ngIf="carouselItems.length === 0" class="page-counter-active">{{counter}}</span> <span
                    *ngIf="carouselItems.length != 0" class="page-counter-active">{{counter +
                    1}}</span>/<span>{{maxPage}}</span>
            </div>
            <button class="arrow" (click)="onPrevious()" [disabled]="counter === 0">
                <img src="assets/images/down-arrow.svg" alt="">
            </button>
            <button class="arrow" (click)="onNext()" [disabled]="this.counter === maxPage - 1">
                <img src="assets/images/up-arrow.svg" alt="">
            </button>
        </div>

    </div>
</div>
<ng-template #factorykpi1>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Zero based Target deviation =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                (Actual Consumption Cost - Zero Based Waste Target Cost)

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                Zero Based Waste Target Cost
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>
    <div class="mt-15">
        Shows the % increase / decrease from previous reporting period
    </div>
</ng-template>
<ng-template #factorykpi2>
    <div class="mb-15">
        % Waste calculated against the total waste cost of the Sub-Region for the selected duration
    </div>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost Contribution By Sub-Region =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                Total Waste of the factory

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                Total Waste of the Sub-Region
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>
<ng-template #factorykpi3>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Unique Line
        </div>

    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;Total number of lines working for the selected period
    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;Count of lines, if there is at least one Production Order fulfilled
        during
        the period
    </div>
</ng-template>
<ng-template #factorykpi4>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Unique SKUs
        </div>

    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;Number of SKUs produced during the selected period
    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;If same SKU is produced more than once, it is counted once
    </div>
</ng-template>
<ng-template #linekpi1>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Zero based Target deviation =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                (Actual Consumption Cost - Zero Based Waste Target Cost)

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                Zero Based Waste Target Cost
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>
    <div class="mt-15">
        Shows the % increase / decrease from previous reporting period for the selected Line
    </div>
</ng-template>
<ng-template #linekpi2>
    <div class="mb-15">
        % Waste calculated against the total waste cost of the Factory for the selected duration
    </div>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost Contribution =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                Total Waste of the Line

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                Total Waste of the Factory
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>
<ng-template #linekpi3>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Production Frequency
        </div>

    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;Production Frequency count is based on the unique actual start date
    </div>
</ng-template>
<ng-template #linekpi4>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Unique SKUs
        </div>

    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;Number of SKUs produced in the selected Line during the selected
        period
    </div>
</ng-template>
<ng-template #totalwastefactory>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Total Waste
        </div>

    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;​Total waste value in Cost displayed in the selected currency for
        the
        factory
    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;​Depicts % difference from the previous reporting period
    </div>
</ng-template>
<ng-template #totalwasteline>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Total Waste
        </div>

    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;​Total waste value in Cost displayed in the selected currency for
        the
        selected Line
    </div>
    <div class="mb-5">
        <em class="fa fa-circle font-12"></em> &nbsp;Depicts % difference from the previous reporting period
    </div>
</ng-template>